import { LoadablePaint } from '@confluence/loadable';

export const LazyLeftPanelExtendedItems = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LeftPanelExtendedItems" */ './LeftPanelExtendedItems'
			)
		).LeftPanelExtendedItems,
});

export const LazyAdministration = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LeftPanelAdministration" */ './LeftPanelAdministration'
			)
		).LeftPanelAdministration,
});

export const LazySpaces = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-LeftPanelSpaces" */ './LeftPanelSpaces'))
			.LeftPanelSpaces,
});
